import styled, { css } from 'styled-components';
import Text from '@components/text';
import { generateScales } from '@helpers/generate-media-queries';
import Image from '@components/image';

export const StyledText = styled(Text)`
  ${({ theme }) => `
    ${generateScales(
      'font-size',
      theme.fontSize.heading2.mobile,
      theme.fontSize.heading2.desktop,
      theme
    )};
    text-align: center;
    color: ${theme.colors.primary};
    ${generateScales('margin-bottom', '2rem', '4rem', theme)}
  `}
`;

export const Subheading = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.secondary};
    text-align: center;
    ${generateScales(
      'font-size',
      theme.fontSize.heading4.mobile,
      theme.fontSize.heading4.desktop,
      theme
    )}
    ${generateScales('margin-bottom', '2rem', '4rem', theme)}
  `}
`;

export const TeamWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;

    @media only screen and (max-width: ${theme.breakpoints.xxl}) {
      gap: 3rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      gap: 3rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      gap: 2.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      gap: 2rem;
      align-items: flex-start;
    }
  `}
`;

export const TitleContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
    text-align: center;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      align-items: flex-start;
      text-align: left;
    }
  `}
`;

export const Divider = styled.div`
  ${({ theme }) => css`
    display: block;
    width: 5rem;
    height: 0.375rem;
    background-color: ${theme.colors.primary};
    border-radius: 0.125rem;
    margin-bottom: 1rem;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      margin-bottom: 0.5rem;
    }
  `}
`;

interface LeaderGridProps {
  items_per_row?: number;
}

export const LeaderGrid = styled.div<LeaderGridProps>`
  ${({ theme, items_per_row }) => css`
    display: grid;
    grid-template-columns: repeat(${items_per_row}, 1fr);
    gap: 2rem;
    margin: 0 auto;
    width: 100%;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      grid-template-columns: repeat(1, 1fr);
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      gap: 1rem;
    }
  `}
`;

export const BioCard = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    background-color: ${theme.colors.light}66;
    padding: 5rem 3rem;
    gap: 4rem;
    border-radius: calc(${theme.borderRadius.large} / 2);
    width: 100%;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      flex-direction: column;
      gap: 2rem;
      padding: 3rem 2.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding: 2rem 1rem;
      gap: 1rem;
    }
  `}
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 1rem;
`;

export const MainInfoContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5rem;
    width: 100%;
    max-width: 30rem;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      align-items: flex-start;
      flex-direction: column;
    }
  `}
`;

export const ImageContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 9rem;
    height: 9rem;
    border-radius: 50%;
    overflow: hidden;

    @media only screen and (max-width: ${theme.breakpoints.xxl}) {
      max-width: 8.5rem;
      height: 8.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      max-width: 8rem;
      height: 8rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      max-width: 7rem;
      height: 7rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      max-width: 8rem;
      height: 8rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      max-width: 8rem;
      height: 8rem;
    }
  `}
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;
